var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('Banner'),_c('div',{staticClass:"global__bg"},[_c('Benefit'),_c('TradeBenefits'),_c('Map'),_c('OnlineForex'),_c('TradeWithEagle'),_c('AboutAffiliates'),_c('HowTo'),_c('FormRequest'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }